/* Styles */
import '../css/swiper-bundle.min.css';

const swiperCatalog = new Swiper('.swiperCatalog', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    slideClass: "swiper-slide",
    loop: false,
    spaceBetween: 20,
    navigation: {
        nextEl: '.swiper__slider-arrow-left',
        prevEl: '.swiper__slider-arrow-right',
    },
});

const swiperDetailing = new Swiper('.swiperDetailing', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    slideClass: "swiper-slide",
    loopedSlides: 3,
    loop: true,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
    },
    spaceBetween: 20,
    navigation: {
        nextEl: '.swiper__slider-arrow-right',
        prevEl: '.swiper__slider-arrow-left',
    },
});

const swiperShares = new Swiper('.swiperShares', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    slideClass: "swiper-slide",
    spaceBetween: 20,
    navigation: {
        nextEl: '.inner-swiper__arrow-right',
        prevEl: '.inner-swiper__arrow-left',
    },
});

const employeeSlider = new Swiper('.employee-swiper', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    slideClass: "swiper-slide",
    // freeMode: true,
    spaceBetween: 20,
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
    navigation: {
        nextEl: '.swiper__slider-arrow-right',
        prevEl: '.swiper__slider-arrow-left',
    },
});

const swiperFullImages = new Swiper(".swiperFullImages", {
    lazy: true,
    spaceBetween: '3%',
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
});
const swiperThumb = new Swiper(".swiperThumb", {
    lazy: true,
    loop: true,
    spaceBetween: 95,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiperFullImages,
    },
});
